/**
 * schemas constants
 */
export const SET_SCHEMA = 'SET_SCHEMA';

export const ENABLE_SCHEMA = 'ENABLE_SCHEMA';
export const ENABLE_SCHEMA_SUCCEEDED = 'ENABLE_SCHEMA_SUCCEEDED';
export const SET_SCHEMA_ENABLED = 'SET_SCHEMA_ENABLED';
export const ENABLE_SCHEMA_ERROR = 'ENABLE_SCHEMA_ERROR';

export const DISABLE_SCHEMA = 'DISABLE_SCHEMA';
export const DISABLE_SCHEMA_SUCCEEDED = 'DISABLE_SCHEMA_SUCCEEDED';
export const SET_SCHEMA_DISABLED = 'SET_SCHEMA_DISABLED';
export const DISABLE_SCHEMA_ERROR = 'DISABLE_SCHEMA_ERROR';

export const SCHEMA_CATEGORY_CHECKLIST = 'CHECKLIST';
